/**
 * Fetches an Akamai EdgeAuth token for the given URL and returns the URL with the token appended.
 * Used for authenticated playback of Akamai CDN (e.g. akamaized.net) content.
 *
 * @param url - Full manifest or asset URL (e.g. https://rlwc2026.akamaized.net/vod/.../manifest.m3u8)
 * @returns The same URL with the hdnts (or configured token name) query parameter appended
 */
export async function getAuthenticatedUrl(url: string): Promise<string> {
    if (!url || typeof url !== 'string') {
      return url;
    }
  
    try {
      const urlObj = new URL(url);
      const path = urlObj.pathname + urlObj.search;
      console.log('urlObj', urlObj);
      console.log('url', url);
      console.log('path', path);
      console.log('encodeURIComponent', encodeURIComponent(path));
      const response = await fetch(`/api/edgeauth?path=${encodeURIComponent(path)}`);
      const data = await response.json();
      console.log('data', data);
      if (data.success && data.token) {
        const separator = url.includes('?') ? '&' : '?';
        const tokenName = data.tokenName || 'hdnts';
        console.log('authenticated url', `${url}${separator}${tokenName}=${data.token}`);
        return `${url}${separator}${tokenName}=${data.token}`;
      }
    } catch {
      // Return original URL on any error
    }
    return url;
  }
  